import React from 'react';
import { useFormContext } from 'react-hook-form';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Typography, TextField, Box, Stack } from '@mui/material';

import { OTPInput, NUMBER_OF_OTP_INPUTS } from '../../components/OTPInput';
import { mfaColors, mfaInputStyles, mfaErrorStyles, mfaOTPContainerStyles } from '../styles';

/**
 * @param {Object} props
 * @param {() => void} props.onSubmit
 */
export const VerificationStep = ({ onSubmit }) => {
  /** @type {import('react-hook-form').UseFormReturn<import('./constants').TOTPVerificationFormType>} */
  const form = useFormContext();
  const {
    formState: { errors },
  } = form;
  const hasError = errors.verificationCode || errors.root?.message;

  return (
    <Stack spacing={3} sx={{ width: '100%' }}>
      <Typography variant="body2" sx={{ color: mfaColors.textMuted, textAlign: 'center' }}>
        Enter the {NUMBER_OF_OTP_INPUTS}-digit code from your authenticator app
      </Typography>

      <Box>
        <Typography variant="body2" sx={{ color: mfaColors.text, fontWeight: 500, mb: 1 }}>
          Display name{' '}
          <Typography component="span" variant="body2" sx={{ color: mfaColors.textMuted }}>
            (optional)
          </Typography>
        </Typography>
        <TextField
          fullWidth
          size="small"
          placeholder="e.g. Google Authenticator"
          {...form.register('displayName')}
          error={!!errors.displayName}
          helperText={errors.displayName?.message || 'A name to identify this authenticator'}
          sx={mfaInputStyles}
        />
      </Box>

      <Box>
        <Typography variant="body2" sx={{ color: mfaColors.text, fontWeight: 500, mb: 1.5 }}>
          Verification code
        </Typography>
        <Box sx={{ ...mfaOTPContainerStyles, borderColor: hasError ? mfaColors.error : mfaColors.border }}>
          <OTPInput onLastInput={onSubmit} />
        </Box>
      </Box>

      {hasError && (
        <Box sx={mfaErrorStyles}>
          <ErrorOutlineIcon sx={{ color: mfaColors.error, fontSize: 18, mt: 0.25 }} />
          <Typography variant="body2" sx={{ color: mfaColors.error }}>
            {errors.verificationCode?.message || errors.root?.message}
          </Typography>
        </Box>
      )}
    </Stack>
  );
};
